import styled from 'styled-components'

const ConversationItemSubject = styled.div`
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	font-size: 14px;
`

export default ConversationItemSubject